var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-button"},[_c('button',{on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('div',{staticClass:"icon"},[_c('share-icon')],1),_c('span',[_vm._v(_vm._s(_vm.buttonText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }